import axios from 'axios';

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {

  async createEMoney({ commit, dispatch, getters }, eMoneyCreate = {}) {


    const { apiPartnerValue: { id }, amount, reference } = eMoneyCreate;

    try{

      const result  = await axios.post('e-money/create',
        {
          api_partner: id,
          amount,
          reference
        }
      );

      return { success: true, message: 'E-money created', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async eMoneyHistory({ commit, dispatch, getters }, pagination = {}) {

    try{

      const { page, rowsPerPage, sortBy, descending } = pagination;

      const result  = await axios.post('e-money/list',
        {
          where: null,
          search: null,
          strict: true,
          pagination: {
            page,
            rowsPerPage,
            sortBy,
            descending
          }
        });

      return { success: true, message: 'E-monies list', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },
}